module.exports = __webpack_public_path__ + "static/img/paris.6f8b5b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hotel/paris.jpg
// module id = ZcER
// module chunks = 1